export function actionNoop() {
    return function(graph) {
        return graph;
    };
}
